<template>
  <div v-if="showModuloForm === false">
    <MarketingModules></MarketingModules>
  </div>

  <CarrosselListagem
    v-else
    tipo-conteudo="PRODUCT_CATEGORY"
    base-route="/fornecedor/customizacao/vitrine-produto"
    carousel-type-variant="type1"
  />
</template>

<script>
import CarrosselListagem from "../carrossel/CarrosselListagem";
import { ModulesEnum } from "@/store/actions/modulesEnum";
import { mapGetters } from "vuex";

export default {
  components: {
    CarrosselListagem
  },
  data() {
    return {
      modulosForm: [
        ModulesEnum.PORTFOLIO_WEB,
        ModulesEnum.ORCAMENTO_WEB,
        ModulesEnum.ORCAMENTO_APP,
        ModulesEnum.VENDAMAIS_WEB,
        ModulesEnum.VENDAMAIS_APP,
        ModulesEnum.WEB_COMMERCE,
        ModulesEnum.COMMERCE_APP
      ]
    };
  },
  computed: {
    ...mapGetters(["moduloFornecedorAtivo"]),
    showModuloForm() {
      return this.moduloFornecedorAtivo(this.modulosForm);
    }
  }
};
</script>
